import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CredentialsPanel from './components/CredentialsPanel';
import CareerSection from './components/CareerSection';
import MediaSection from './components/MediaSection';
import PracticeSection from './components/PracticeSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CredentialsPanel />
        <CareerSection />
        <MediaSection />
        <PracticeSection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}